import { EvidenceExportPathFormat } from '@mi-front/core';
import { Box } from '@mui/material';
import { TextFieldElement } from 'react-hook-form-mui';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

export interface GipPathFormatCustomTextFieldProps {
  pathFormats: EvidenceExportPathFormat[];
}

/**
 * Shows the custom path text input when the **currently selected** path format (from RHF state)
 * contains the {{CUSTOM_TEXT}} placeholder in its pattern.
 */
export function GipPathFormatCustomTextField({ pathFormats }: GipPathFormatCustomTextFieldProps) {
  const { control } = useFormContext();
  const formatId = useWatch({ control, name: 'pathFormat.formatId' });
  const currentFormat = pathFormats.find((opt) => opt.id === formatId);
  const showCustomField = Boolean(currentFormat?.pattern.includes('{{CUSTOM_TEXT}}'));

  if (!showCustomField) {
    return null;
  }

  return (
    <Box mb={2}>
      <TextFieldElement
        name="pathFormat.formatCustomText"
        label={
          <FormattedMessage
            id="audit.gipReport.export.customTextInPath"
            defaultMessage="Texto custom en path"
          />
        }
        fullWidth
        required
      />
    </Box>
  );
}
